import { StudentScore } from '~teacher/models/activities';

export const studentQuestionQuestionScore = (studentScore: StudentScore) =>
  studentScore?.score ?? null;
